<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="28px"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col> -->
        <v-col cols="4">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="dialog = true"
                :disabled="selectedRows.length > 0"
                class="ml-5 header_btn"
              >
                <v-icon size="28px"> mdi-file-plus-outline </v-icon>
                <span class="lable_class">Add</span>
                
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="assignRemoveFormDialog(true)"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-plus-circle-multiple-outline</v-icon>
                 <span class="lable_class">Assign</span>
              </v-btn>
            </template>
            <span>Assign form(s) on selected records</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="assignRemoveFormDialog(false)"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-delete-sweep</v-icon>
                 <span class="lable_class">Remove</span>
              </v-btn>
            </template>
            <span>Remove form(s) from selected records</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled
              class="ml-7 header_btn">
                <v-icon size="28px"> mdi-eye-outline </v-icon>
                <span class="lable_class">View</span>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                @click="delete_dialog = true"
                class="ml-7 header_btn"
              >
                <v-icon size="28px"> mdi-delete-outline </v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>
        <v-col cols="4">
           <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="setData({key : 'selected_alphabet',value : ''})" icon small dark v-bind="attrs" v-on="on" class="ml-1 header_btn">
                <v-badge overlap dot :value="search" color="error">
                  <span class="lable_class">Search</span>
                  <v-icon size="28px">mdi-magnify</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="300">
              <v-row no-gutters>
            <v-col cols="12" class="">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                v-debounce:500="getVendorType"
                single-line
                hide-details
                dense
                solo
                clearable
                v-on:keyup.enter="search_menu = false"
                autofocus
              ></v-text-field>
            </v-col>
          </v-row>
            </v-card>
           </v-menu>
           <v-menu bottom :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on" disabled class="ml-8 header_btn">
                <v-icon size="22px" >mdi-filter-menu-outline</v-icon>
                <span class="lable_class">Filter</span>
              </v-btn>
            </template>
           </v-menu>
        </v-col>
        <v-col cols="4" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">Vendor Type
            <v-icon class="error--text ml-2" size="30" style="color:#ffffff  !important" @click="logout()" >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
        <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
      </v-overlay>
    <v-card flat tile>
      
      <v-card-text
        class="pa-0 mx-auto"
      >
        <v-row dense="" style="width:100%" class="pa-0 ma-0">
          <v-col cols="1" class="pa-0 ma-0" style="max-width: 2.5%;">
            <AlphabetSort />
          </v-col>
          <v-col class="pt-0 pr-0">
            <v-data-table
              :headers="headers"
              class="full-footer-bar elevation-1 rounded-0 my-transaction-table small-table fix-table-layout fix-table-header custom-width-550"
              item-key="user_id"
              :search="search"
              :items="items.data"
              :server-items-length="items.total"
              :options.sync="pagination"
              mobile-breakpoint="50"
              @item-expanded="expandRow"
              dense
              :footer-props="{
                'items-per-page-options': pagination_settings.perPageList,
              }"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td width="3%">
                    <v-icon @click="editRecord(item.v_type_id)">
                      mdi-clipboard-edit-outline
                    </v-icon>
                  </td>
                  <td width="7%">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                    ></v-simple-checkbox>
                  </td>
                  <td width="43%">
                    {{item.vendor_type}}
                  </td>
                  <td width="43%">
                    <!-- {{getModuleName(item.modules)}} -->
                    <v-autocomplete
                      style="margin-top: -1px;"
                      :items="module_list"
                      dense=""
                      v-model="modules[items.data.indexOf(item)]"
                      hide-details=""
                      multiple=""
                      @change="changeFormModule(items.data.indexOf(item),item)"
                    >
                      <template v-slot:selection="{index}">                                         
                        <span class="grey--text caption" v-if="index == 0">
                          {{selected_modules(items.data.indexOf(item))}}
                        </span>
                      </template>
                    </v-autocomplete>
                  </td>
                </tr>
              </template>
              <template v-slot:header.select_all>
                <v-simple-checkbox
                  v-model="select_all_checkbox"
                  @input="changeSelectAll()"
                  color="white"
                  :ripple="false"
                  class="select-all-checkbox custom-simple-box"
                ></v-simple-checkbox>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="300px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Add Vendor Type</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  label="Vendor Type*"
                  v-model="form_data.vendor_type"
                  :error-messages="form_error.vendor_type"
                  :hide-details="!form_error.vendor_type"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="mt-1">
                <v-autocomplete
                  :items="module_list"
                  label="Form Name"
                  dense=""
                  v-model="form_data.modules"
                  :error-messages="form_error.modules"
                  :hide-details="!form_error.modules"
                  multiple=""
                >
                  <template v-slot:selection="{ index }">
                    <span class="grey--text caption" v-if="index == 0">
                      {{selected_multi_values}}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="dialog = false;form_data = {};form_error = {}">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addJobType"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_dialog" persistent max-width="300px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Update Vendor Type</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  label="Vendor Type*"
                  v-model="edit_form_data.vendor_type"
                  :error-messages="edit_form_error.vendor_type"
                  :hide-details="!edit_form_error.vendor_type"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="mt-1">
                <v-autocomplete
                  :items="module_list"
                  label="Form Name"
                  dense=""
                  v-model="edit_form_data.modules"
                  :error-messages="edit_form_error.modules"
                  :hide-details="!edit_form_error.modules"
                  multiple=""
                >
                  <template v-slot:selection="{ index }">
                    <span class="grey--text caption" v-if="index == 0">
                      {{selected_multi_values2}}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="edit_dialog = false;edit_form_data = {};edit_form_error = {}">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="updateJobtype"> Update </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline"> Confirmation </v-card-title>
        <v-card-text>
          Are you sure you want to delete selected vendor types?
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_dialog = false">
            Cancel
          </v-btn>
          <v-btn color="red darken-1" text @click="delete_dialog = false; deleteVendorType()">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="assign_remove_form_dialog" persistent max-width="300px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">{{(is_assign_form)?'Assign Form(s)':'Remove Form(s)'}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-autocomplete
                  :items="module_list"
                  label="Form Name"
                  dense=""
                  v-model="selected_forms"
                  hide-details
                  multiple=""
                >
                  <template v-slot:selection="{ index }">
                    <span class="grey--text caption" v-if="index == 0">
                      {{selected_multi_values3}}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="assign_remove_form_dialog = false;selected_forms = [];">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="selected_forms.length == 0" @click="assignRemoveForms"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { parseParams, getAlphabets, logout } from "../../plugins/helper";
import AlphabetSort from "../AlphabetSort";
import { mapState,mapMutations } from "vuex";
export default {
  name: "UsersList",
  data() {
    return {
      modules: [],
      dialog: false,
      edit_dialog:false,
      delete_dialog: false,
      is_assign_form: null,
      selected_forms: [],
      assign_remove_form_dialog: false,
      form_data: {
        modules: []
      },
      form_error: {},
      edit_form_data: {
        modules: []
      },
      edit_form_error: {},
      search: "",
      form_loading:false,
      loading: false,
      v_type_id: null,
      items: {
        data: [],
      },
      select_all_checkbox: false,
      headers: [
        { value: "", text: "", sortable: false, class:'', width: '7%' },
        { value: "select_all", text: "", sortable: false, width:"7%", class:'pl-0' },
        { value: "vendor_type", text: "Name", sortable: true, width:"43%" },
        { value: "", text: "Form Name", sortable: false, width:"43%" },
      ],
      module_list: [
        { value: "TRANSACTION", text: "Trasaction"},
        { value: "ITEM", text: "Item Master"},
        { value: "JOB", text: "Job Master"},
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["vendor_type"],
        page: 1,
        filters: {
          item_active: true,
          alphabet: "",
        },
      },
      alphabets: getAlphabets(),
      expanded: [],
      search_menu : false
    };
  },
  components: {
    AlphabetSort
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    ...mapState("submenu", ["selected_alphabet"]),
    selected_multi_values3() {
      let return_data = ''
      if(this.selected_forms.length > 0) {
        this.module_list.filter((item) => {
          if(item.value == this.selected_forms[0]) {
            return_data = item.text
          }
        })
        if(this.selected_forms.length > 1) {
          let totalVen = this.selected_forms.length - 1;
          return_data = return_data + ' ('+totalVen+' More)'
        }
      }
      return return_data;
    },
    selected_multi_values() {
      let return_data = ''
      if(this.form_data.modules.length > 0) {
        this.module_list.filter((item) => {
          if(item.value == this.form_data.modules[0]) {
            return_data = item.text
          }
        })
        if(this.form_data.modules.length > 1) {
          let totalVen = this.form_data.modules.length - 1;
          return_data = return_data + ' ('+totalVen+' More)'
        }
      }
      return return_data;
    },
    selected_multi_values2() {
      let return_data = ''
      if(this.edit_form_data.modules.length > 0) {
        this.module_list.filter((item) => {
          if(item.value == this.edit_form_data.modules[0]) {
            return_data = item.text
          }
        })
        if(this.edit_form_data.modules.length > 1) {
          let totalVen = this.edit_form_data.modules.length - 1;
          return_data = return_data + ' ('+totalVen+' More)'
        }
      }
      return return_data;
    },
    selectedRows() {
      return this.items.data.filter(function (item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "vendor_type";
      return paginationData;
    },
    getStyles() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return {
          maxWidth: "95%",
          margin: "0 auto",
        };
      } else {
        return {};
      }
    },
  },
  watch: {
    selected_alphabet(val) {
      this.pagination.filters.alphabet = val
    },
    pagination: {
      handler: function () {
        this.getVendorType();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations("submenu", ["setData"]),
    ...mapMutations("utils", ["setAlert"]),
    assignRemoveForms() {
      let ids = []
      this.selectedRows.map(function(item){
        ids.push(item.v_type_id)
      })
      let _self = this;
      _self.form_loading = true;
      axios.post("assign_remove_vendor_type_form", {forms: this.selected_forms, is_assign_form: this.is_assign_form, ids: ids})
        .then(() => {
          _self.form_loading = false;
          _self.assign_remove_form_dialog = false
          _self.getVendorType()
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    assignRemoveFormDialog(is_assign_form) {
      this.is_assign_form = is_assign_form;
      this.selected_forms = [];
      this.assign_remove_form_dialog = true;
    },
    changeSelectAll() {
      if (this.select_all_checkbox) {
        this.items.data = this.items.data.map((item) => {
          item.selected = true;
          return item;
        });
      } else {
        this.items.data = this.items.data.map((item) => {
          item.selected = false;
          return item;
        });
      }
    },
    changeFormModule(index,item) {
      let _self = this;
      this.loading = true;
      let data = {};
      data.v_type_id = item.v_type_id
      data.vendor_type  = item.vendor_type
      data.modules = this.modules[index]
      axios.post("update_vendor_types", data)
        .then(() => {
          _self.loading = false;
        })
        .catch(function () {
          _self.loading = false;
        });
    },
    selected_modules(index) {
      let selected_modules = this.modules[index];
      let return_data = ''
      if(selected_modules.length > 0) {
        this.module_list.filter((item) => {
          if(item.value == selected_modules[0]) {
            return_data = item.text
          }
        })
        if(selected_modules.length > 1) {
          let totalVen = selected_modules.length - 1;
          return_data = return_data + ' ('+totalVen+' More)'
        }
      }
      return return_data;
    },
    getModuleName(module_code) {
      let module_name = ''
      module_code.filter((item) => {
        this.module_list.filter((item2) => {
          if(item2.value == item.form_code) {
            if(module_name) {
              module_name = module_name+', '+item2.text
            } else {
              module_name = item2.text
            }
          }
        })
      })
      return module_name
    },
    editRecord(v_type_id) {
      this.v_type_id = v_type_id;
      this.edit_dialog=true;
      this.getVendorTypeDetails(v_type_id)
    },
    getFormatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    expandRow(itemData) {
      if(itemData.value) {
        this.items.data = this.items.data.map(function(item){
          if(item.user_id == itemData.item.user_id) {
            item.selected = true
          }
          return item
        })
      }
    },
    getVendorType() {
      let _self = this;
      this.loading = "accent";
      let url = parseParams(this.pageData);
      axios.get("vendor_type_list?" + url)
        .then((response) => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
          _self.setData({key : 'alphabets',value : response.data.alphabets})
          let item_data = _self.items.data
          for (let key in item_data) {
            _self.modules[key] = []
            for (let key2 in item_data[key].modules) {
              _self.modules[key].push(item_data[key].modules[key2].form_code)
            }
          }
          _self.select_all_checkbox = false
          _self.loading = false;
        })
        .catch(function () {
          _self.loading = false;
        });
    },
    addJobType() {
      let _self = this;
      // this.loading = "accent";
      _self.form_loading = true;
      axios.post("add_vendor_types", _self.form_data)
        .then((response) => {
          let data = response.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
             _self.form_data = {};
            _self.form_error = {};
            _self.dialog = false
            //_self.items.data.push(data.data)
             _self.getVendorType();
          }
        })
        .catch(function () {
          _self.form_loading = false;
        }).then(() => {
          this.form_loading = false;
        })
    },
    updateJobtype(){
      let _self = this;
      this.form_loading = true;
      _self.edit_form_data.v_type_id = _self.v_type_id
      axios.post("update_vendor_types", _self.edit_form_data)
        .then((response) => {
          let data = response.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.edit_form_error[key] = data.errors[key][0];
            }
          } else {
            _self.edit_form_data = {};
            _self.edit_form_error = {};
            _self.edit_dialog = false
            _self.getVendorType();
          }
        })
        .catch(function () {
          _self.form_loading = false;
        }).then(() => {
          this.form_loading = false;
        })
    },
    getVendorTypeDetails(v_type_id){
      let _self = this
      _self.form_loading= true;
      axios.get("get_vendor_type_details?v_type_id="+v_type_id)
        .then((response) => {
          let data = response.data.data;
          _self.edit_form_data.vendor_type = data.vendor_type;
          _self.edit_form_data.modules = []
          for(let key in data.modules) {
            _self.edit_form_data.modules.push(data.modules[key].form_code)
          }
          _self.form_loading = false;
        })
        .catch(function () {
          _self.form_loading = false;
        });
    },
    deleteVendorType(){
      let _self = this
      let ids = []
      this.selectedRows.map(function(item){
        ids.push(item.v_type_id)
      })
      axios.post("delete_vendor_types",{
        ids : ids
      }).then(function(response){
          _self.setAlert({
          show: true,
          variant: response.data.variant,
          message: response.data.message,
          dismissCountDown: 0
        });
        _self.getVendorType()
      })
      .catch(function(){
        console.log('FAILURE!!');
      });
    },
    logout() {
      logout(this.$router)
    }
  },
  mounted() {
    this.getVendorType();
  },
};
</script>